import TrackProAPI from './track-pro-api'

export const getUserNotifications = (dateRange: any) => {
    const endpoint = dateRange
        ? `/user/notifications?start_date=${dateRange.startDate}&end_date=${dateRange.endDate}`
        : '/user/notifications'
    return TrackProAPI.get(endpoint)
}

export const deleteSingleNotification = async (notification_id: any) => {
    const { data } = await TrackProAPI.delete('/user/notifications', {
        data: { notification_id },
    })
    return data
}

export const clearNotifications = () => {
    return TrackProAPI.delete('/user/notifications/deleteAll')
}
